
const cp = [
    {
    "name": "Godrej Genteel Top load and Front load Fresh Liquid Detergent",
    "price": "₹  296 / 1 kg",
    "priceint": 296,
    "weight": "1 kg",
    "src": require("./Godrej Genteel Top load and Front load Fresh Liquid Detergent.webp")
    },
    {
    "name": "Surf excel Detergent Bar",
    "price": "₹  112 / 4x200 g",
    "priceint": 112,
    "weight": "4x200 g",
    "src": require("./Surf excel Detergent Bar.webp")
    },
    {
    "name": "Rin Detergent Bar",
    "price": "₹  100 / 4x250 g",
    "priceint": 100,
    "weight": "4x250 g",
    "src": require("./Rin Detergent Bar.webp")
    },
    {
    "name": "Ghadi Detergent Powder 3 kg",
    "price": "₹  181 / 3 kg",
    "priceint": 181,
    "weight": "3 kg",
    "src": require("./Ghadi Detergent Powder 3 kg.webp")
    },
    {
    "name": "Surf excel Easy Wash Detergent Powder 500 g",
    "price": "₹  62 / 500 g",
    "priceint": 62,
    "weight": "500 g",
    "src": require("./Surf excel Easy Wash Detergent Powder 500 g.webp")
    },
    {
    "name": "Tide Plus Double Power Lemon & Mint Detergent Powder 4 kg",
    "price": "₹  499 / 4 kg",
    "priceint": 499,
    "weight": "4 kg",
    "src": require("./Tide Plus Double Power Lemon & Mint Detergent Powder 4 kg.webp")
    },
    {
    "name": "Ariel Matic Front Load Fresh Liquid Detergent",
    "price": "₹  414 / 2 L",
    "priceint": 414,
    "weight": "2 L",
    "src": require("./Ariel Matic Front Load Fresh Liquid Detergent.webp"),
    },
    {
    "name": "Surf excel Matic Top Load Liquid Detergent",
    "price": "₹  112 / 0.5 L",
    "priceint": 112,
    "weight": "0.5 L",
    "src": require("./Surf excel Matic Top Load Liquid Detergent.webp"),
    },
    {
    "name": "Ghadi Detergent Cake 250 x 5 Detergent Bar",
    "price": "₹  76 / 5x250 g",
    "priceint": 76,
    "weight": "5x250 g",
    "src": require("./Ghadi Detergent Cake 250 x 5 Detergent Bar.webp"),
    },
    {
        "name": "Surf excel Matic Front Load Liquid Detergent",
        "price": "₹  186 / 1 L",
        "priceint": 186,
        "weight": "1 L",
        "src": require("./Surf excel Matic Front Load Liquid Detergent.webp"),
        },
        {
        "name": "Morelight Extra Power Detergent Powder 4 kg",
        "price": "₹  230 / 4 kg",
        "priceint": 230,
        "weight": "4 kg",
        "src": require("./Morelight Extra Power Detergent Powder 4 kg.webp"),
        },
        {
        "name": "Dynamite by Flipkart Detergent Powder 3 kg",
        "price": "₹  160 / 3 kg",
        "priceint": 160,
        "weight": "3 kg",
        "src": require("./Dynamite by Flipkart Detergent Powder 3 kg.webp"),
        },
        {
        "name": "Tide Ultra Semi-Auto & Hand Wash Detergent Powder 5 kg",
        "price": "₹  501 / 5 kg",
        "priceint": 501,
        "weight": "5 kg",
        "src": require("./Tide Ultra Semi-Auto & Hand Wash Detergent Powder 5 kg.webp"),
        },
        {
        "name": "Comfort After Wash Morning Fresh Fabric Conditioner",
        "price": "₹  54 / 210 ml",
        "priceint": 54,
        "weight": "210 ml",
        "src": require("./Comfort After Wash Morning Fresh Fabric Conditioner.webp"),
        },
    {
    "name": "Exo Dishwash Bar",
    "price": "₹  25 / 3x90 g",
    "priceint": 25,
    "weight": "3x90 g",
    "src": require("./Exo Dishwash Bar.webp"),
    },
    {
    "name": "Exo Touch & Shine Round Dishwash Bar",
    "price": "₹  51 / 500 g",
    "priceint": 51,
    "weight": "500 g",
    "src": require("./Exo Touch & Shine Round Dishwash Bar.webp"),
    },
    {
    "name": "Flipkart Supermart Dish Cleaning Gel",
    "price": "₹  170 / 2 L",
    "priceint": 170,
    "weight": "2 L",
    "src": require("./Flipkart Supermart Dish Cleaning Gel.webp"),
    },
    {
    "name": "Flipkart Supermart Home Essentials Lemon Dishwash Bar",
    "price": "₹  39 / 3x200 g",
    "priceint": 39,
    "weight": "3x200 g",
    "src": require("./Flipkart Supermart Home Essentials Lemon Dishwash Bar.webp"),
    },
    {
    "name": "Vim Dish Cleaning Gel",
    "price": "₹  169 / 0.75 L",
    "priceint": 169,
    "weight": "0.75 L",
    "src": require("./Vim Dish Cleaning Gel.webp"),
    },
    {
    "name": "Exo Anti-bacterial Dishwash Bar",
    "price": "₹  28 / 250 g",
    "priceint": 28,
    "weight": "250 g",
    "src": require("./Exo Anti-bacterial Dishwash Bar.webp"),
    },
    {
    "name": "Pril Grease Fighter Dish Cleaning Gel",
    "price": "₹  279 / 1.5 L",
    "priceint": 279,
    "weight": "1.5 L",
    "src": require("./Pril Grease Fighter Dish Cleaning Gel.webp"),
    },
    {
    "name": "Flipkart Supermart Home Essentials Dish Cleaning Gel",
    "price": "₹  43 / 0.3 L",
    "priceint": 43,
    "weight": "0.3 L",
    "src": require("./Flipkart Supermart Home Essentials Dish Cleaning Gel.webp"),
    },
    {
    "name": "Giffy Lemon and Active Salt Dish Wash Utensil Cleaner, Tough Stain Removal Dish Cleaning Gel",
    "price": "₹  190 / 2x0.5 L",
    "priceint": 190,
    "weight": "2x0.5 L",
    "src": require("./Giffy Lemon and Active Salt Dish Wash Utensil Cleaner, Tough Stain Removal Dish Cleaning Gel.webp"),
    },
    {
        "name": "Lizol Disinfectant Surface and Floor Cleaner Citrus",
        "price": "₹  213 / 2x625 ml",
        "priceint": 213,
        "weight": "2x625 ml",
        "src": require("./Lizol Disinfectant Surface and Floor Cleaner Citrus.webp"),
        },
        {
        "name": "Lizol Disinfectant Surface and Floor Cleaner Floral",
        "price": "₹  217 / 2x625 ml",
        "priceint": 217,
        "weight": "2x625 ml",
        "src": require("./Lizol Disinfectant Surface and Floor Cleaner Floral.webp"),
        },
        {
        "name": "Flipkart Supermart Home Essentials Floor and Bathroom Cleaner Phenyl Jasmine",
        "price": "₹  100 / 2x1 L",
        "priceint": 100,
        "weight": "2x1 L",
        "src": require("./Flipkart Supermart Home Essentials Floor and Bathroom Cleaner Phenyl Jasmine.webp"),
        },
        {
        "name": "GAINDA White Perfumed Disinfectant Phenyl Plain",
        "price": "₹  168 / 5 L",
        "priceint": 168,
        "weight": "5 L",
        "src": require("./GAINDA White Perfumed Disinfectant Phenyl Plain.webp"),
        },
        {
        "name": "Flipkart Supermart Floor and Bathroom Cleaner Jasmine",
        "price": "₹  190 / 5 L",
        "priceint": 190,
        "weight": "5 L",
        "src": require("./Flipkart Supermart Floor and Bathroom Cleaner Jasmine.webp"),
        },
        {
        "name": "Harpic Disinfectant Bathroom Cleaner Liquid Lemon",
        "price": "₹  179 / 1 L",
        "priceint": 179,
        "weight": "1 L",
        "src": require("./Harpic Disinfectant Bathroom Cleaner Liquid Lemon.webp"),
        },
        {
        "name": "Harpic Disinfectant Bathroom Cleaner Floral",
        "price": "₹ 168 / 1 L",
        "priceint": 168,
        "weight": "1 L",
        "src": require("./Harpic Disinfectant Bathroom Cleaner Floral.webp"),
        },
        {
        "name": "Lizol Disinfectant Surface Cleaner Citrus",
        "price": "₹ 640 / 5 L",
        "priceint": 640,
        "weight": "5 L",
        "src": require("./Lizol Disinfectant Surface Cleaner Citrus.webp"),
        }

]

export default cp;